import React from 'react';
import { ButtonBase } from '@mui/material';
import classNames from 'classnames';
import { generatePath } from 'react-router-dom';
import MaterialIcon from 'commons/src/components/MaterialIcon';
import HealthSummary from '../../features/status/buildingStatus/summaryBar/HealthSummary';
import { OrganizationBuildingOverview } from '../../models/organizationHealthModels';
import { RenderedProps } from '../collapsibleTable/models';
import styles from './BuildingRowHeader.module.scss';

type BuildingRowHeaderProps = RenderedProps & {
    showLink?: boolean;
    additionalNameClassName?: string;
};

const BuildingRowHeader = ({
    data,
    toggle,
    opened,
    id,
    showLink = false,
    additionalNameClassName,
}: BuildingRowHeaderProps): React.ReactElement => {
    const rowData = data as OrganizationBuildingOverview;
    const noDataToDisplay = !rowData.hubStats.total && !rowData.deviceStats.total;
    const buildingTo = generatePath('/buildings/:locationId/status', { locationId: rowData.locationId });

    const nameClassName = classNames(styles.buildingName, additionalNameClassName);

    return (
        <div className={styles.rowHeader}>
            <ButtonBase
                data-testid={`collapse_button_${id}`}
                className={classNames(styles.toggleButton, { [styles.visuallyHidden]: noDataToDisplay })}
                onClick={toggle}
                centerRipple={false}
                disabled={noDataToDisplay}
            >
                <MaterialIcon name={opened ? 'expand_less' : 'chevron_right'} />
            </ButtonBase>
            <header className={styles.headerContent} data-testid={`collapse_header_${id}`}>
                <div className={styles.buildingsInfo}>
                    {showLink ? (
                        <a
                            href={buildingTo}
                            target="_blank"
                            rel="noreferrer"
                            className={nameClassName}
                            title={rowData.locationName}
                        >
                            {rowData.locationName}
                        </a>
                    ) : (
                        <span className={nameClassName} title={rowData.locationName}>
                            {rowData.locationName}
                        </span>
                    )}
                </div>
                <div className={styles.summaryWrapper}>
                    <HealthSummary isHub stats={rowData.hubStats} showOnlyValues />
                </div>
                <div className={styles.summaryWrapper}>
                    <HealthSummary isHub={false} stats={rowData.deviceStats} showOnlyValues />
                </div>
            </header>
        </div>
    );
};

export default BuildingRowHeader;
